import { useMemo } from "react";

import type { Margin } from "~/v2/api/rest/account";
import { LOCALE_OPTIONS } from "~/v2/constants/optionOrder";

export interface BuyingPowerResult {
  display: string;
  label: string;
}

interface GetBuyingPowerArgs {
  margin: Margin | undefined;
}

export const getBuyingPower = ({
  margin,
}: GetBuyingPowerArgs): BuyingPowerResult => ({
  display: parseFloat(margin?.options_buying_power || "0").toLocaleString(
    "en-US",
    LOCALE_OPTIONS,
  ),
  label: "Buying Power",
});

interface UseBuyingPowerProps {
  margin: Margin | undefined;
}

export const useBuyingPower = ({ margin }: UseBuyingPowerProps) => {
  return useMemo(() => getBuyingPower({ margin }), [margin]);
};
